"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _core = require("@material-ui/core");

var StylesAtributes = function StylesAtributes(_ref) {
  var properties = _ref.properties,
      handlePropertyChange = _ref.handlePropertyChange,
      handleItemAttribute = _ref.handleItemAttribute;
  var cssValue = properties.customStyles || "{}";
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_core.FormControlLabel, {
    control: /*#__PURE__*/React.createElement(_core.Switch, {
      name: "required",
      color: "primary",
      checked: properties.isActiveCustomStyles || false,
      onChange: function onChange(e, checked) {
        handlePropertyChange(properties, "isActiveCustomStyles", checked);
      }
    }),
    label: "Activar estilo personalizado"
  }), /*#__PURE__*/React.createElement(_core.TextareaAutosize, {
    "aria-label": "minimum height",
    minRows: 3,
    placeholder: "Coloca los estilos en JSON. \\n E.g.: {\"background\":\"red\"}",
    value: cssValue,
    defaultValue: cssValue,
    onChange: function onChange(e) {
      //handleItemAttribute(properties, "customStyles", '{"background":"yellow","color":"blue"}');            }}
      handlePropertyChange(properties, "customStyles", e.target.value);
    }
  }));
};

var _default = StylesAtributes;
exports.default = _default;